'use strict';

exports.__esModule = true;
exports.header = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _headerActions = require('../actions/header-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {};

var header = exports.header = function header(state, action) {
	switch (action.type) {
		case _headerActions.ON_TAB_SELECTED:
			return (0, _assign2.default)({}, state, { selectedTab: action.tab, previousTab: state.selectedTab });
		default:
			return state || INITIAL_STATE;
	}
};